import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../utils/api';

export const useGuidePage = (page, retry) => {
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    const controller = new AbortController();
    let objectUrl;
    setState({ loading: true, page });
    const config = { withCredentials: true, signal: controller.signal };
    Promise.all([
      axios.get(`${getApiUrl()}/book/pages/${page}`, config),
      axios.get(`${getApiUrl()}/book/pages/${page}/image`, { ...config, responseType: 'blob' }),
    ]).then(([info, image]) => {
      if (controller.signal.aborted) return;
      objectUrl = URL.createObjectURL(image.data);
      setState({ loading: false, page, info: info.data, image: objectUrl });
    }).catch((error) => {
      if (!controller.signal.aborted) setState({ loading: false, page, error: error.response?.status === 404 ? 'Cette page est introuvable.' : 'Impossible de charger cette page. Réessayez.' });
    });
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [page, retry]);
  return state.page === page ? state : { loading: true };
};